import { ComponentInstall } from "../../utils";
import Card from "./src";

export default ComponentInstall(Card);
